import React, { 
    useState, 
    useEffect, 
    useContext,
} from "react"

import {
    Context,
} from "../../../Model/Contexts/AppContext"

import "./style.css"

import { 
    ButtonGroup, 
} from "react-bootstrap"

import EMETLSegmentedControlButton from "../EMETLSegmentedControlButton"

export type PropsModel = {
    wrapperClass?: string,
    labelName?: string,
    options: Array<string>,
    perform: (idx: number) => void,
    selectedTab?: number,
}

const EMETLSegmentedControl = (props?: PropsModel) => {
    const {
        mode,
    } = useContext(Context)

    const { 
        wrapperClass, 
        labelName, 
        options, 
        perform, 
        selectedTab, 
    } = props

    const [currentTabIndex, setCurrentTabIndex] = useState(selectedTab ?? 0)

    /**
     * Sets the currently selected button.
     * 
     * @param {string} option - String value of the selected option
     */
    const clickHandler = (option: string) => {
        setCurrentTabIndex(options.indexOf(option))
        perform(options.indexOf(option))
    }

    useEffect(() => {
        if (selectedTab !== undefined && selectedTab !== currentTabIndex)
            setCurrentTabIndex(selectedTab)
    }, [selectedTab])

    return (
        <div className={wrapperClass ?? "scWrapper"}>
            <ButtonGroup 
                id={labelName ?? "searchSegmentedControl"} 
                aria-label={labelName ?? "searchSegmentedControl"}>
                {
                    options.map((option, i) => (
                        <EMETLSegmentedControlButton 
                            key={option} 
                            option={option}
                            selected={currentTabIndex === i}
                            perform={() => clickHandler(option)}
                        />
                    ))
                }
            </ButtonGroup>
        </div>
    )
}

export default EMETLSegmentedControl